import React, {Component} from 'react';
import {ThemeProvider} from 'styled-components';
import 'flexboxgrid/dist/flexboxgrid.css';
import GoogleAnalytics from "react-ga";
import homeImage from '../assets/images/envimate-home.png'

import {GlobalStyle} from './theme/global-styles'
import {Location} from "@reach/router";
import theme from './theme/theme'
import BlogMainPage from "../pages/BlogMainPage/BlogMainPage";
import {MainHelmet} from "../pages/Articles/components/SocialShare/Helmets";
import Footer from "../shared-components/Footer/Footer";
import {siteData} from "../pages/Articles/articleDb";

class Template extends Component {
    state = {
        theme: theme('light'),
    };

    render() {
        const imageAlt = "envimate's official blog";
        return (
            <ThemeProvider theme={this.state.theme}>
                <div>
                    <MainHelmet
                        imageAlt={imageAlt}
                        image={homeImage}
                        title={siteData.title}
                        description={siteData.description}


                    />
                    <Location>
                        {({location}) => {
                                GoogleAnalytics.pageview(location.pathname);
                            }
                        }
                    </Location>
                    <GlobalStyle/>
                    <BlogMainPage/>
                    <Footer/>
                </div>
            </ThemeProvider>
        );
    }
}

export default Template;
